import { async } from 'regenerator-runtime/runtime';
import { API_KEY, API_URL, RES_PER_PAGE } from './config.js';
import { AJAX } from './helper.js';

export const state = {
  recipe: {},
  search: {
    query: '',
    results: [],
    page: 1,
  },
  bookmarks: [],
};

export const loadRecipe = async function (id) {
  try {
    const data = await AJAX(`${API_URL}${id}?key=${API_KEY}`);
    state.recipe = structuredClone(data.data.recipe);
    if (state.bookmarks.some(bookRecipe => bookRecipe.id === state.recipe.id))
      state.recipe.bookmarked = true;
    else state.recipe.bookmarked = false;
  } catch (e) {
    throw Error(e);
  }
};
export const loadSearchResults = async function (query) {
  try {
    state.search.query = query;
    const data = await AJAX(`${API_URL}?search=${query}&key=${API_KEY}`);
    state.search.results = structuredClone(data.data.recipes);
    state.search.page = 1;
  } catch (e) {
    throw Error(e);
  }
};
export const loadSearchResultsPage = function (page = state.search.page) {
  state.search.page = page;
  const start = (page - 1) * RES_PER_PAGE;
  const end = page * RES_PER_PAGE;
  return state.search.results.slice(start, end);
};
export const updateServings = function (servings) {
  state.recipe.ingredients.forEach(ing => {
    if (ing.quantity)
      ing.quantity = (ing.quantity / state.recipe.servings) * servings;
  });
  state.recipe.servings = servings;
};
const persistBookmarks = function () {
  localStorage.setItem('bookmarks', JSON.stringify(state.bookmarks));
};
export const addBookmarks = function (recipe) {
  state.bookmarks.push(recipe);
  if (recipe.id === state.recipe.id) state.recipe.bookmarked = true;
  persistBookmarks();
};
export const deleteBookmarks = function (id) {
  const index = state.bookmarks.findIndex(bookmark => bookmark.id === id);
  state.bookmarks.splice(index, 1);
  if (id === state.recipe.id) state.recipe.bookmarked = false;
  persistBookmarks();
};
export const addRecipe = async function (data) {
  try {
    const ingredients = Object.entries(data)
      .filter(data => data[0].startsWith('ingredient') && data[1])
      .map(data => {
        const details = data[1].split(',').map(el => el.trim());
        if (details.length !== 3)
          throw new Error(
            'Wrong format ingrediant! please use correct formate :)'
          );
        return {
          quantity: details[0] ? +details[0] : null,
          unit: details[1],
          description: details[2],
        };
      });
    const recipe = {
      publisher: data.title,
      source_url: data.sourceUrl,
      image_url: data.image,
      title: data.title,
      servings: +data.servings,
      ingredients: ingredients,
      cooking_time: +data.cookingTime,
    };
    const dataRes = await AJAX(`${API_URL}?key=${API_KEY}`, recipe);
    recipe.id = dataRes.data.recipe.id;
    state.recipe = recipe;
  } catch (e) {
    throw e;
  }
};
const init = function () {
  const storge = localStorage.getItem('bookmarks');
  if (storge) state.bookmarks = JSON.parse(storge);
};
init();
